import Cookies from 'js-cookie'

const TokenKey = 'cps_user_token'
const UserId = 'cps_user_id'
const v_code = 'vcode'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // document.addCookie('game_user_token=' + token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setUserId(id) {
  return Cookies.set(UserId, id)
}

export function getUserId() {
  return Cookies.get(UserId)
}

export function removeUserId() {
  return Cookies.remove(UserId)
}
export function setVcode(val=1) {
  return Cookies.set(v_code,val)
}
export function getVcode() {
  return Cookies.get(v_code)
}
